module.exports = __webpack_public_path__ + "school/img/jihuo.18a6e3c7.jpg";